'use strict';

module.exports = require('./Trigger');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.10.4@rc-trigger/lib/index.js
 ** module id = 45
 ** module chunks = 0 1
 **/